var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.33068C0 4.7647 6.62274e-08 3.48172 0.484411 2.50164C0.910522 1.63954 1.59043 0.938636 2.42671 0.499368C3.37743 -2.04817e-07 4.62199 0 7.11111 0H12.8889C15.378 0 16.6226 -2.04817e-07 17.5733 0.499368C18.4096 0.938636 19.0894 1.63954 19.5156 2.50164C20 3.48172 20 4.7647 20 7.33068V8.70519C20 11.2712 20 12.5541 19.5156 13.5343C19.0894 14.3963 18.4096 15.0972 17.5733 15.5365C16.6226 16.0359 15.378 16.0359 12.8889 16.0359H4.90468C4.61 16.0359 4.32738 16.1566 4.11901 16.3714L1.89679 18.6622C1.19682 19.3838 0 18.8727 0 17.8523V16.0359V10.3088V7.33068ZM6.66667 4.58168C6.05302 4.58168 5.55556 5.0945 5.55556 5.7271C5.55556 6.35969 6.05302 6.87251 6.66667 6.87251H13.3333C13.947 6.87251 14.4444 6.35969 14.4444 5.7271C14.4444 5.0945 13.947 4.58168 13.3333 4.58168H6.66667ZM6.66667 9.16335C6.05302 9.16335 5.55556 9.67616 5.55556 10.3088C5.55556 10.9414 6.05302 11.4542 6.66667 11.4542H10C10.6137 11.4542 11.1111 10.9414 11.1111 10.3088C11.1111 9.67616 10.6137 9.16335 10 9.16335H6.66667Z",
    fill: "#8B857E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.0763a50b5cf3a215981ed8db5ab17e20.svg";
export { ForwardRef as ReactComponent };